import ServerPageInterface from 'server/types/ServerPageInterface'
import structureType from 'common/constants/structureTypes'
import { migrateFullTwoStepPaymentForm } from 'tools/commands/migrate/two-step-payment-form/migrate-two-step-payment-form'
import { migrateMultipleCommand } from 'tools/commands/migrate/utils/migrateMultipleCommand'

export default function (page: ServerPageInterface) {
  return migrateMultipleCommand({
    page,
    structureTypes: [
      structureType.TWO_STEP_PAYMENT_FORM,
      structureType.TWO_STEP_PAYMENT_FORM_STEP_OPT_IN,
      structureType.TWO_STEP_PAYMENT_FORM_STEP_PAYMENT,
    ],
    migrateFunction: migrateFullTwoStepPaymentForm,
  })
}
